<sc-flex vertical fitHeight stretchContent
    class="no-field-space article-type-attribute-editor">

    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-attribute-editor.title"></sc-dictionary-label>
    </sc-dialog-title>

    <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
            <sc-padding>
                <form [formGroup]="formGroup">
                    <sc-flex vertical stretchContent>
                        <div>
                            <sc-flex >

                              <mat-form-field appearance="fill" class="identifierPattern">
                                <mat-label>
                                  <sc-dictionary-label dictionaryKey="erp.entity.articletype.id"></sc-dictionary-label>
                                </mat-label>
                                <input matInput formControlName="id" [disabled]="true">
                              </mat-form-field>

                              <sc-content-spacer></sc-content-spacer>

                                <mat-form-field appearance="fill" class="input-group">
                                    <mat-label>
                                      <sc-dictionary-label dictionaryKey="erp.entity.articletypeattribute.group"></sc-dictionary-label>
                                    </mat-label>
                                    <mat-select formControlName="group" [required]="true">
                                        <mat-option *ngFor="let group of articleType.attributeGroups" [value]="group">
                                            <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <sc-content-spacer></sc-content-spacer>

                                <mat-form-field appearance="fill">
                                    <mat-label>
                                      <sc-dictionary-label dictionaryKey="erp.entity.articletypeattribute.sort-order"></sc-dictionary-label>
                                    </mat-label>
                                    <input matInput formControlName="sortValue">
                                </mat-form-field>
                            </sc-flex>
                        </div>
                        <sc-content-spacer vertical></sc-content-spacer>
                        <div>
                            <sc-flex >
                                <mat-form-field appearance="fill">
                                    <mat-label>
                                      <sc-dictionary-label dictionaryKey="erp.entity.articletypeattribute.type"></sc-dictionary-label>
                                    </mat-label>
                                    <mat-select formControlName="type" [required]="true">
                                        <mat-option *ngFor="let attributeType of attributeTypes"
                                            [value]="attributeType">
                                            {{ attributeType }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <sc-content-spacer></sc-content-spacer>
                                <sc-dictionary-field class="input-title" [model]="attribute?.name" [maxlength]="255"
                                    defaultLabel="Name" labelDictionaryKey="erp.entity.articletypeattribute.name"
                                    (dictionaryChanged)="onTitleChanged($event)" [required]="true">
                                </sc-dictionary-field>
                            </sc-flex>
                        </div>
                        <sc-content-spacer vertical></sc-content-spacer>

                        <div>
                            <sc-flex >
                                <mat-checkbox class="input-mandatory" formControlName="mandatory">
                                  <sc-dictionary-label dictionaryKey="erp.entity.articletypeattribute.mandatory"></sc-dictionary-label>
                                </mat-checkbox>
                                <sc-content-spacer *ngIf="!lookupType"></sc-content-spacer>
                                <mat-form-field class="input-default-value" appearance="fill" *ngIf="!lookupType">
                                    <mat-label>
                                      <sc-dictionary-label dictionaryKey="erp.entity.articletypeattribute.defaultvalue"></sc-dictionary-label>
                                    </mat-label>
                                    <input matInput formControlName="defaultValue">
                                </mat-form-field>
                            </sc-flex>
                        </div>
                    </sc-flex>
                </form>
                <ng-container *ngIf="lookupType">
                    <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                    <sc-sub-title>
                      <sc-dictionary-label dictionaryKey="erp.ui.articletype-attribute-editor.subtitle.lookupvalues"></sc-dictionary-label>
                      <sc-content-spacer grow></sc-content-spacer>
                      <button mat-stroked-button (click)="addValue()">
                          <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                          <sc-dictionary-label dictionaryKey="erp.ui.articletype-attribute-editor.action.add-lookupvalue"></sc-dictionary-label>
                      </button>
                    </sc-sub-title>
                    <ng-container *ngFor="let value of attribute?.values">
                        <ng-container *ngIf="value.deleted === false">
                            <sc-content-spacer vertical></sc-content-spacer>
                            <div class="value-item" #lookupValueForm>
                                <sc-padding>
                                    <sc-flex *ngIf="selectedValue !== value">
                                        <div>{{value.value}} <span *ngIf="value?.id === attribute.defaultValueId">
                                                (default)</span></div>
                                        <sc-content-spacer grow></sc-content-spacer>
                                        <button mat-icon-button class="edit-button" (click)="selectValue(value)">
                                            <mat-icon>
                                                <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
                                            </mat-icon>
                                        </button>
                                        <button mat-icon-button (click)="removeValue(value)">
                                            <sc-action-icon iconClass="fa-trash"></sc-action-icon>
                                        </button>
                                    </sc-flex>
                                    <form [formGroup]="valueFormGroup" *ngIf="selectedValue === value">
                                        <sc-flex >
                                            <mat-form-field appearance="fill" class="input-value">
                                                <mat-label>
                                                  <sc-dictionary-label dictionaryKey="erp.entity.articletype.articletypeattribute.lookupvalue"></sc-dictionary-label>
                                                </mat-label>
                                                <input #lookupValueInput name="lookupValueInput" matInput formControlName="value" >
                                            </mat-form-field>
                                            <sc-content-spacer></sc-content-spacer>
                                            <mat-form-field appearance="fill" class="">
                                              <mat-label>
                                                <sc-dictionary-label dictionaryKey="erp.entity.articletype.articletypeattribute.lookupsortvalue"></sc-dictionary-label>
                                              </mat-label>
                                              <input #lookupValueInput name="lookupSortValueInput" matInput formControlName="sortValue" >
                                          </mat-form-field>
                                          <sc-content-spacer></sc-content-spacer>
                                            <mat-checkbox class="input-default-value-flag" formControlName="default"
                                                *ngIf="value?.id !== attribute.defaultValueId">
                                                <sc-dictionary-label dictionaryKey="erp.entity.articletype.articletypeattribute.default"></sc-dictionary-label>
                                            </mat-checkbox>
                                            <div *ngIf="value?.id === attribute.defaultValueId">
                                                (default)</div>
                                        </sc-flex>
                                    </form>
                                </sc-padding>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </sc-padding>
        </sc-scroll-pane>
    </sc-flex-fitting-content>

    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">Abbrechen</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">Übernehmen</button>
    </sc-actionbar>
</sc-flex>
